(function() {
	'use strict';

	angular.module('paymentRates').service('PaymentRatesService',
			PaymentRatesService);

	function PaymentRatesService(RemoteService, PaymentRatesFactory) {
		var self = this;

		self.getFlyingHourRates = function(param, successFn, errorFn) {
			RemoteService
					.getFlyingHourRates(param)
					.then(
							function(response) {
								var paymentHourRangeDTOs = PaymentRatesFactory
										.formatFlyingHourRatesResponse(response.paymentHourRangeDTOs);
								successFn(paymentHourRangeDTOs);
							}, function(msg) {
								errorFn(msg);
							});
		}

		self.saveFlyingHourRates = function(param, successFn, errorFn) {
			var paymentHourRangeDTOs = PaymentRatesFactory
					.formatFlyingHourRatesRequest(param);
			RemoteService.saveFlyingHourRates(paymentHourRangeDTOs).then(
					function(response) {
						successFn(response);
					}, function(msg) {
						errorFn(msg);
					});
		}

		self.deleteFlyingHourRates = function(param, successFn, errorFn) {
			var paymentHourRangeDTOs = PaymentRatesFactory
					.formatFlyingHourRatesRequestForDelete(param);
			RemoteService.deleteFlyingHourRates(paymentHourRangeDTOs).then(
					function(response) {
						successFn(response);
					}, function(msg) {
						errorFn(msg);
					});
		}

		self.getOtherPaymentRates = function(param, successFn, errorFn) {
			RemoteService
					.getOtherPaymentRates(param)
					.then(
							function(response) {
								var otherPaymentDTOs = PaymentRatesFactory
										.formatOtherPaymentRatesResponse(response.otherPaymentRateDto);
								successFn(otherPaymentDTOs);
							}, function(msg) {
								errorFn(msg);
							});
		}

		self.saveOtherPaymentRates = function(param, successFn, errorFn) {
			var otherPaymentRatesDTOs = PaymentRatesFactory
					.formatOtherPaymentRequestForSave(param);
			RemoteService.saveOtherPaymentRates(otherPaymentRatesDTOs).then(
					function(response) {
						successFn(response);
					}, function(msg) {
						errorFn(msg);
					});

		}

	}

})();